require('./mortgageRequestHolderEconomicFormHasMortgage.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { contains } = require('lodash');
const { connect } = require('react-redux');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');

// @core
const { formatText, getLanguage } = require('core/i18n').i18n;

// @helpers
const { formatCurrency } = require('utilities/currencyHelper');
const { stringToBoolean } = require('utilities/stringHelper');
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @actions
const holderEconomicActions = require('actions/mortgageRequest/mortgageRequestHolderEconomic');

// @constants
const currencyFormatted = formatCurrency('EUR');
const { APPROVED_STATES_DATA_PROPRIETOR } = require('constants/mortgageRequestPanelStates');
const { OTHER_LOANS_TYPES } = require('constants/mortgageRequestHolderData');
const { DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES, DRAG_N_DROP_UPLOAD_TITLE } = require('constants/commonsComponents');
const { HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER } = require('constants/flagBasedFeatures');

class MortgageEconomicFormHasMortgage extends React.Component {
    constructor(props) {
        super(props);

        const { immAnotherLoan, immDocument } = props;

        this.state = {
            loanType: immAnotherLoan.get('type') || OTHER_LOANS_TYPES.MORTGAGE,
            cancelLoan: immAnotherLoan.get('amountToPay') > 0,
            amountToPay: immAnotherLoan.get('amountToPay') || 0,
            pendingAmount: immAnotherLoan.get('pendingAmount') || 0,
            file: immDocument ? true : null,
            pendingAmountValid: true,
            amountToPayValid: true,
            fileValid: true,
            isSaving: false
        };

        this.setFieldValue = this.setFieldValue.bind(this);
        this.isValidCurrency = this.isValidCurrency.bind(this);
        this.handleChangeLoanType = this.handleChangeLoanType.bind(this);
        this.handleChangeCancelLastMortgages = this.handleChangeCancelLastMortgages.bind(this);
        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    setFieldValue(value, evt) {
        const { name } = evt.target;
        this.setState({ [name]: value });
        this.isValidCurrency(name, value);
    }

    handleChangeCancelLastMortgages(value) {
        this.setState({ cancelLoan: stringToBoolean(value) });
    }

    handleChangeLoanType(value) {
        this.setState({ loanType: value });
    }

    handleOnChangeFile(fileState) {
        if (fileState) {
            if (!fileState.error) {
                this.setState({
                    file: fileState.file,
                    fileValid: true
                });
            }
        }
    }

    handleCancel() {
        this.props.onEditStateChange(false);
    }

    handleSave() {
        const {
            saveOtherLoans,
            holderDocument,
            onEditStateChange,
            immAnotherLoan,
            immFlagBasedFeatures
        } = this.props;
        const ffHideDocument = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER));
        const saveOtherLoansCB = saveOtherLoans({
                documentNumber: holderDocument.numeroDocumento,
                documentType: holderDocument.tipoDocumentoIdentidad,
                amountToPay: this.state.amountToPay,
                pendingAmount: this.state.pendingAmount,
                type: this.state.loanType,
                id: immAnotherLoan.get('id')
            },
            this.state.file
        );

        if (ffHideDocument) {
            this.validateData() &&
            this.setState(
                {isSaving: true},
                () => saveOtherLoansCB.then(() => onEditStateChange(false, true))
            );

        } else {
            this.setState(
                {isSaving: true},
                () => saveOtherLoansCB.then(() => onEditStateChange(false, false))
            );
        }
    }

    isValidCurrency(name, value) {
        const thisName = `${name}Valid`;
        const isValid = value !== 0;
        this.setState({
            [thisName]: isValid,
        });
    }

    validateData() {
        if (!this.state.file) {
            this.setState({ fileValid: false });
            return false;
        }
        return true;
    }

    render() {
        const { holderEconomic, mortgageRequestState, immAnotherLoan, immDocument, onDownload, immFlagBasedFeatures } = this.props;
        const cancelAnotherMortgage = holderEconomic.get('quiereCancelarOtraHipoteca');
        const currentState = mortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(APPROVED_STATES_DATA_PROPRIETOR, currentState);
        const ammountFiles = immDocument ? 1 : 0;
        const documentType = immDocument ? immDocument.get('tipoDocumentoId') : '';
        const loanId = immAnotherLoan.get('id') || '';
        const language = getLanguage();
        const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, multiples, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES);
        const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const MSG_FORM_ERROR_IS_REQUIRED = formatText('mortgageRequestCommons-defaultFormError');
        const ffHideDocument = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER));
        let labelCancelLoan;

        if (this.state.loanType === OTHER_LOANS_TYPES.MORTGAGE) {
            labelCancelLoan = formatText('mortgageRequestHolderEconomic-labelCancelMortgage');
        } else {
            labelCancelLoan = formatText('mortgageRequestHolderEconomic-labelVaCancelarHipoteca');
        }

        const cancelLoanAmountInputElement = this.state.cancelLoan && (
            <div className="row mortgage-request-holder-economic-has-mortgage__block">
                <div className="col-md-6">
                    <div className="mortgage-request-holder-economic-has-mortgage__input">
                        <div className="mortgage-request-holder-economic-has-mortgage__amount">
                            <AmountInput
                                name="amountToPay"
                                label={formatText('mortgageRequestHolderEconomic-otherLoansFormAmountToPayLabel')}
                                callback={this.setFieldValue}
                                amount={this.state.amountToPay}
                                maxFractionLength={2}
                                error={!this.state.pendingAmountValid}
                                errorMsg={MSG_FORM_ERROR_IS_REQUIRED}
                                showBlurZero
                                language={language}
                                disabled={isApprovedDataProprietor}
                            />
                        </div>
                        <div className="mortgage-request-holder-economic-has-mortgage__currency-symbol currency-two-line">
                            {currencyFormatted}
                        </div>
                    </div>
                </div>
            </div>
        );
        const isLoading = this.state.isSaving || holderEconomic.get('isSavingOtherLoan');
        const isDisabled = isApprovedDataProprietor || this.state.isSaving || holderEconomic.get('isSavingOtherLoan');
        const isLoanTypeMortgage = this.state.loanType === OTHER_LOANS_TYPES.MORTGAGE;
        const otherLoansFormFileUploadLabel = formatText(
            'mortgageRequestHolderEconomic-otherLoansFormFileUploadLabel',
            [
                isLoanTypeMortgage
                    ? formatText('mortgageRequestHolderEconomic-mortgageRequestHolderEconomic_otherLoansFormFileUploadLabelMortgage')
                    : formatText('mortgageRequestHolderEconomic-mortgageRequestHolderEconomic_otherLoansFormFileUploadLabelPersonal')
            ]
        );

        return (
            <div className="mortgage-request-holder-economic-has-mortgage">
                <div className="row mortgage-request-holder-economic-has-mortgage__block">
                    <div className="col-md-12">
                        <h4>{formatText('mortgageRequestHolderEconomic-otherLoansFormTitle')}</h4>
                        <p>{formatText('mortgageRequestHolderEconomic-otherLoansFormSubtitle')}</p>
                    </div>
                </div>
                <div className="row mortgage-request-holder-economic-has-mortgage__block">
                    <div className="col-md-6">
                        <RadioButtonGroup
                            name="loanType"
                            idPrefix="changeOtherLoanType"
                            selectedValue={this.state.loanType}
                            onChange={this.handleChangeLoanType}
                            label={formatText('mortgageRequestHolderEconomic-otherLoansFormLoanTypeLabel')}
                            errorState={cancelAnotherMortgage}
                            errorMessage={MSG_FORM_ERROR_IS_REQUIRED}
                            isHorizontal
                        >
                            <RadioButton
                                label={formatText('mortgageRequestHolderEconomic-otherLoansFormMortgageLabel')}
                                value={OTHER_LOANS_TYPES.MORTGAGE}
                                className="block-step__radio"
                                disabled={isApprovedDataProprietor}
                            />
                            <RadioButton
                                label={formatText('mortgageRequestHolderEconomic-otherLoansFormPersonalLabel')}
                                value={OTHER_LOANS_TYPES.PERSONAL_LOAN}
                                className="block-step__radio"
                                disabled={isApprovedDataProprietor}
                            />
                        </RadioButtonGroup>
                    </div>
                </div>
                <div className="row mortgage-request-holder-economic-has-mortgage__block">
                    <div className="col-md-6">
                        <RadioButtonGroup
                            name="quiereCancelarOtraHipoteca"
                            idPrefix="changequiereCancelarOtraHipoteca"
                            selectedValue={this.state.cancelLoan}
                            onChange={this.handleChangeCancelLastMortgages}
                            label={labelCancelLoan}
                            errorState={cancelAnotherMortgage}
                            errorMessage={MSG_FORM_ERROR_IS_REQUIRED}
                            isHorizontal
                        >
                            <RadioButton
                                label={formatText('mortgageRequestHolderEconomic-labelSiCancelarHipoteca')}
                                value
                                className="block-step__radio"
                                disabled={isApprovedDataProprietor}
                            />
                            <RadioButton
                                label={formatText('mortgageRequestHolderEconomic-labelMantenerHipoteca')}
                                value={false}
                                className="block-step__radio"
                                disabled={isApprovedDataProprietor}
                            />
                        </RadioButtonGroup>
                    </div>
                </div>
                <div className="row mortgage-request-holder-economic-has-mortgage__block">
                    <div className="col-md-6">
                        <div className="mortgage-request-holder-economic-has-mortgage__input">
                            <div className="mortgage-request-holder-economic-has-mortgage__amount">
                                <AmountInput
                                    name="pendingAmount"
                                    label={formatText('mortgageRequestHolderEconomic-labelimporteTotalPendiente')}
                                    callback={this.setFieldValue}
                                    disabled={isApprovedDataProprietor}
                                    error={!this.state.pendingAmountValid}
                                    errorMsg={MSG_FORM_ERROR_IS_REQUIRED}
                                    amount={this.state.pendingAmount}
                                    maxFractionLength={2}
                                    showBlurZero
                                    language={language}
                                    maxIntegerLength={8}
                                />
                            </div>
                            <div className="mortgage-request-holder-economic-has-mortgage__currency-symbol currency-two-line">
                                {currencyFormatted}
                            </div>
                        </div>
                    </div>
                </div>
                {cancelLoanAmountInputElement}
                {
                    ffHideDocument && (
                        <div className="row mortgage-request-holder-economic-has-mortgage__block">
                            <div className="col-md-6">
                                <h5>{otherLoansFormFileUploadLabel}</h5>
                                <br/>
                                <DragNDropUpload
                                    idName="otherLoansFile"
                                    onChange={this.handleOnChangeFile}
                                    loading={holderEconomic.get('isSavingOtherLoan')}
                                    overwriteFile
                                    disabled={isApprovedDataProprietor}
                                    error={!this.state.fileValid}
                                    errorMessage={MSG_FORM_ERROR_IS_REQUIRED}
                                    fileText={documentType}
                                    ammountFiles={ammountFiles}
                                    onDownload={() => onDownload(documentType, loanId)}
                                    texts={texts}
                                    title={DRAG_N_DROP_UPLOAD_TITLE}
                                    textDescription={textDescription}
                                    textLinkDescription={textLinkDescription}
                                />
                            </div>
                        </div>
                    )

                }
                <div className="row mortgage-request-holder-economic-has-mortgage__block">
                    <hr />
                    <div className="col-md-2 col-md-offset-8">
                        <div>
                            <OKButton
                                modifier="ghost"
                                disabled={isApprovedDataProprietor || isLoading}
                                onClick={() => this.handleCancel()}
                            >
                                {formatText('mortgageRequestCommons-cancelText')}
                            </OKButton>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div>
                            <OKButton
                                modifier="secondary"
                                disabled={isDisabled}
                                onClick={() => this.handleSave()}
                                loading={isLoading}
                            >
                                {formatText('mortgageRequestHolderEconomic-otherLoansFormAddText')}
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageEconomicFormHasMortgage.propTypes = {
    holderEconomic: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    saveOtherLoans: PropTypes.func,
    holderDocument: PropTypes.object.isRequired,
    onEditStateChange: PropTypes.func.isRequired,
    immAnotherLoan: PropTypes.object,
    onDownload: PropTypes.func.isRequired,
    immDocument: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
};

module.exports.MortgageEconomicFormHasMortgage = connect(
    state => ({
        holderEconomic: state.mortgageRequestHolderEconomic,
        mortgageRequestState: state.mortgageRequestState,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
        saveOtherLoans: holderEconomicActions.saveOtherLoans
    }
)(MortgageEconomicFormHasMortgage);
